import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useMemo } from "react";
import { useSessionStorage } from "usehooks-ts";

import ChevronIcon from "$/lib/icons/ChevronIcon";
import { InfoIcon } from "$/lib/icons/InfoIcon";
import { useMinimumYearSelector } from "$/lib/utils/functions/minimumYear.functions";

import { Info } from "../../atoms/Info/Info";
import { StandaloneSelect } from "../../other/StandaloneSelect";

const YearDropDown = () => {
  const [sessionStorageYearValue, setSessionStorageYearValue] =
    useSessionStorage("management-year", new Date().getFullYear());

  const queryClient = useQueryClient();

  const handleYearChange = (year: number) => {
    setSessionStorageYearValue(year);
  };

  const currentYear = new Date().getFullYear();
  const minimumYear = useMinimumYearSelector();

  const years = useMemo(
    () =>
      Array.from(
        { length: currentYear - minimumYear + 1 },
        (_, i) => minimumYear + i,
      ),
    [currentYear, minimumYear],
  );

  useEffect(() => {
    queryClient.invalidateQueries();
  }, [sessionStorageYearValue]);

  return (
    <div className="flex w-[134px] flex-col items-end gap-1 overflow-visible">
      <div className="flex w-full items-center justify-center gap-2">
        <span className="text-xs font-medium text-textInfo">Année estimée</span>
        <Info
          info={`Les estimations sont réalisées sur les chiffres de l’année en cours. Les régularisations de l’année ${sessionStorageYearValue} seront reçues en ${sessionStorageYearValue + 1}.`}
          className="h-fit w-fit border-none bg-transparent p-0 text-transparent"
        >
          <InfoIcon fill="#696680" width={11} height={11} />
        </Info>
      </div>
      <StandaloneSelect<string>
        name="value"
        options={years.map((value) => ({
          label: value.toString(),
          value: value.toString(),
        }))}
        contentClassName="text-center [&>*>*]:!text-[20px] [&>*>*]:py-1.5 [&>*>*]:!cursor-pointer ml-auto !min-h-11"
        iconClassName="w-2.5"
        selectClassName="!py-[2px] px-2 !min-h-[unset] !h-auto [&>span:first-child]:mx-auto font-semibold gap-0 rounded-md text-[20px] max-w-[134px]  focus:outline-none focus:ring-0"
        className="min-w-[134px]"
        hideLabel
        placeholder=""
        label=""
        onChange={(value) => {
          handleYearChange(Number(value));
          (document.activeElement as HTMLElement)?.blur();
        }}
        defaultValue={sessionStorageYearValue.toString()}
        icon={<ChevronIcon className="rotate-90" width={18} height={18} />}
      />
    </div>
  );
};

export default YearDropDown;
